import createActionType from "@/redux/utils/createActionType";

export const MODULE = "sales-order/page-filter";

export const SET_FILTER = createActionType(MODULE, "setFilter");

export const RESET = createActionType(MODULE, "reset");
